import { getMahapackDemoVideoFetcher } from "@api/fetcher/ambassdor";
import { useQuery } from "@tanstack/react-query";

interface props {
    data: any;
    isLoading: boolean;
}

interface queryProps {
    type?: string;
    typeId?: string;
    ids?: string;
}

const useGetMahapackDemoVideos = ({
    enabled,
    query,
}: {
    enabled: boolean;
    query: queryProps;
}): props => {
    const { data, isLoading } = useQuery({
        queryKey: ["get-mahapack-demo-videos", { query }],
        queryFn: ({ queryKey }) => getMahapackDemoVideoFetcher({ queryKey }),
        retry: false,
        enabled: !!enabled,
        refetchOnWindowFocus: false,
    });

    return {
        data,
        isLoading,
    };
};

export default useGetMahapackDemoVideos;
